import { Link } from "react-router-dom";
import { ArrowUpRight, CheckIcon, SearchIcon, ShieldCheckIcon } from "@/components/icons";
import { useDocumentMeta } from "@/src/use-document-meta";

export function AboutPage() {
  useDocumentMeta({
    title: "About | Chuno",
    description: "Chuno is a clearer, source-aware way to discover current jobs across India.",
    canonical: "https://www.chuno.work/about",
  });

  return (
    <main id="main" className="about-page">
      <section className="about-hero">
        <div className="shell about-hero__inner">
          <p className="eyebrow"><span /> About Chuno</p>
          <h1>Job search deserves<br />better signal.</h1>
          <p>Chuno brings current opportunities from across India into one considered, easy-to-use place—so your energy goes into choosing, not hunting.</p>
        </div>
      </section>
      <section className="section about-story">
        <div className="shell about-story__grid">
          <p className="section-kicker">The idea</p>
          <div>
            <h2>Built for a deliberate next move.</h2>
            <p>Most job boards are designed around volume. The result is familiar: repeated listings, unclear sources, closed roles, and too much time spent separating useful information from noise.</p>
            <p>Chuno takes a more focused approach. We organise structured job data around the questions that matter: What is the role? Where is it? How does the team work? Is the opening current? What should I do next?</p>
          </div>
        </div>
      </section>
      <section className="section about-method">
        <div className="shell">
          <div className="section-heading"><div><p className="section-kicker">Our approach</p><h2>Simple on the surface.<br />Rigorous underneath.</h2></div></div>
          <div className="method-grid">
            <article><span>01</span><SearchIcon /><h3>Bring the market together</h3><p>Search roles from employers, startups, public-sector organisations, and other hiring sources across India.</p></article>
            <article><span>02</span><ShieldCheckIcon /><h3>Keep the source in view</h3><p>Job information stays connected to the underlying hiring source and is refreshed as the market changes.</p></article>
            <article><span>03</span><CheckIcon /><h3>Make choosing easier</h3><p>Consistent titles, locations, work models, qualifications, and responsibilities make roles easier to compare.</p></article>
          </div>
        </div>
      </section>
      <section className="about-cta">
        <div className="shell about-cta__inner"><h2>See what’s open now.</h2><Link className="button button--lime" to="/jobs">Find jobs <ArrowUpRight /></Link></div>
      </section>
    </main>
  );
}
